import type { CSSProperties } from 'react';
import { cn } from '../../../utils/cn';
import styles from './Skeleton.module.css';

export type SkeletonVariant = 'text' | 'rect' | 'circle';

export interface SkeletonProps {
  variant?: SkeletonVariant;
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: CSSProperties;
  /** ARIA label override; defaults to "Loading" */
  label?: string;
}

export function Skeleton({
  variant = 'text',
  width,
  height,
  className,
  style,
  label = 'Loading',
}: SkeletonProps) {
  const computedStyle: CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    ...style,
  };

  return (
    <span
      aria-busy
      aria-label={label}
      role="status"
      className={cn(styles.skeleton, styles[variant], className)}
      style={computedStyle}
    />
  );
}
